import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsGruntComponent } from './simple-icons-grunt.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsGruntComponent ],
    exports:      [ SimpleIconsGruntComponent ],
    bootstrap:    []
})
export class SimpleIconsGruntModule {}
